import { Injectable } from '@angular/core';

@Injectable()
export class GrowlerService {
    constructor() { }
    growl: (message: string, title: string, titleClass: string, icon: string) => number;
}
